module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      open: _vm.showDropdown
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": function($event) {
        _vm.showDropdown = false
      },
      "keydown": [function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.hit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.reset($event)
      }, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    ref: "dropdown",
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.items), function(item, i) {
    return _c('li', {
      class: {
        active: _vm.isActive(i)
      }
    }, [_c('a', {
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.hit($event)
        },
        "mousemove": function($event) {
          _vm.setActive(i)
        }
      }
    }, [_c(_vm.templateComp, {
      tag: "component",
      attrs: {
        "item": item
      }
    })], 1)])
  }))])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d28c4a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d28c4a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Typeahead.vue
// module id = 302
// module chunks = 0